// Div.AI Chatbot Email Handler
window.DivAIEmailHandler = {
  async submitConsultationRequest(formData) {
    try {
      // Method 1: Try Shopify contact form
      await this.submitToShopifyContact(formData);
      
      // Method 2: If available, use a custom webhook or email service
      await this.submitToCustomEndpoint(formData);
      
      return { success: true };
    } catch (error) {
      console.error('Error submitting consultation request:', error);
      return { success: false, error: error.message };
    }
  },

  async submitToShopifyContact(formData) {
    const shopifyFormData = new FormData();
    shopifyFormData.append('contact[name]', formData.name);
    shopifyFormData.append('contact[email]', formData.email || 'divai-consultation@divayur.com');
    shopifyFormData.append('contact[phone]', formData.phone);
    shopifyFormData.append('contact[body]', this.formatEmailBody(formData));

    const response = await fetch('/contact', {
      method: 'POST',
      body: shopifyFormData,
      headers: {
        'Accept': 'application/json, text/plain, */*',
      }
    });

    if (!response.ok) {
      throw new Error('Failed to submit to Shopify contact form');
    }

    return response;
  },

  async submitToCustomEndpoint(formData) {
    // This could be integrated with services like EmailJS, Formspree, or custom webhook
    // For now, we'll prepare the data structure for future integration
    
    const emailData = {
      to: 'herbal@divayur.com',
      subject: 'New Consultation Request from Div.AI',
      html: this.formatEmailHTML(formData),
      text: this.formatEmailBody(formData)
    };

    // If you have a custom email endpoint, uncomment and configure:
    /*
    const response = await fetch('/api/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(emailData)
    });

    if (!response.ok) {
      throw new Error('Failed to submit to custom endpoint');
    }
    */

    // For now, just log the data that would be sent
    console.log('Email data prepared for herbal@divayur.com:', emailData);
    
    return Promise.resolve();
  },

  formatEmailBody(formData) {
    return `
🌿 NEW CONSULTATION REQUEST FROM DIV.AI CHATBOT

📋 Patient Details:
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

👤 Name: ${formData.name}
📅 Age/Gender: ${formData.age_gender}
📱 Phone/WhatsApp: ${formData.phone}
📧 Email: ${formData.email || 'Not provided'}

🏥 Health Information:
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

🔍 Main Health Concern: ${formData.concern}
⏰ Preferred Consultation Time: ${formData.preferred_time}

📊 Request Details:
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

📅 Submitted: ${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })} IST
🌐 Website: ${window.location.hostname}
🤖 Source: Div.AI Chatbot Widget
📱 User Agent: ${navigator.userAgent}

⚡ ACTION REQUIRED: Please contact the patient within 24 hours to schedule their consultation.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
🌿 Divayur - Traditional Ayurvedic Wellness
    `.trim();
  },

  formatEmailHTML(formData) {
    return `
<!DOCTYPE html>
<html>
<head>
  <style>
    body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
    .header { background: linear-gradient(135deg, #FFD700, #FFA500); color: white; padding: 20px; text-align: center; }
    .content { padding: 20px; }
    .section { margin-bottom: 25px; padding: 15px; border-left: 4px solid #FFD700; background: #f9f9f9; }
    .field { margin: 10px 0; }
    .label { font-weight: bold; color: #B8860B; }
    .value { color: #333; margin-left: 10px; }
    .footer { background: #f1f1f1; padding: 15px; text-align: center; font-size: 0.9rem; }
    .urgent { background: #fff3cd; border-color: #ffeaa7; color: #856404; }
  </style>
</head>
<body>
  <div class="header">
    <h1>🌿 New Consultation Request</h1>
    <p>Div.AI Chatbot - Divayur.com</p>
  </div>
  
  <div class="content">
    <div class="section urgent">
      <h3>⚡ Action Required</h3>
      <p>Please contact the patient within 24 hours to schedule their consultation.</p>
    </div>
    
    <div class="section">
      <h3>👤 Patient Information</h3>
      <div class="field">
        <span class="label">Name:</span>
        <span class="value">${formData.name}</span>
      </div>
      <div class="field">
        <span class="label">Age/Gender:</span>
        <span class="value">${formData.age_gender}</span>
      </div>
      <div class="field">
        <span class="label">Phone/WhatsApp:</span>
        <span class="value">${formData.phone}</span>
      </div>
      <div class="field">
        <span class="label">Email:</span>
        <span class="value">${formData.email || 'Not provided'}</span>
      </div>
    </div>
    
    <div class="section">
      <h3>🏥 Health Information</h3>
      <div class="field">
        <span class="label">Main Health Concern:</span>
        <span class="value">${formData.concern}</span>
      </div>
      <div class="field">
        <span class="label">Preferred Consultation Time:</span>
        <span class="value">${formData.preferred_time}</span>
      </div>
    </div>
    
    <div class="section">
      <h3>📊 Request Details</h3>
      <div class="field">
        <span class="label">Submitted:</span>
        <span class="value">${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })} IST</span>
      </div>
      <div class="field">
        <span class="label">Website:</span>
        <span class="value">${window.location.hostname}</span>
      </div>
      <div class="field">
        <span class="label">Source:</span>
        <span class="value">Div.AI Chatbot Widget</span>
      </div>
    </div>
  </div>
  
  <div class="footer">
    <p>🌿 <strong>Divayur</strong> - Traditional Ayurvedic Wellness</p>
    <p>This email was automatically generated by the Div.AI chatbot on your website.</p>
  </div>
</body>
</html>
    `.trim();
  }
};